import mutations from './mutations/index'
import actions from './actions/index'
import getters from './getters/index'

const state = {
  uid: 0,

  cupId: 0,
  kid: 0, // 当前kid
  // gameId: 0,
  klines: null,

  nextTradingDay: '',
  // cupInfo: null,
  player: null,
  _cupPlayer: null,
  gameInfo: null,
  qInfo: null,

  // cup
  cupsMap: null,

  // 训练记录
  gamesList: null,
  gamesMap: null,

  // 训练页数据索引
  playInfo: null,

  // 排行
  myRank: 0,
  _rankList: null,

  // 用户信
  userMap: null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
